import { Component } from 'react'
import { Row, Col, Space, Typography, Spin } from 'antd'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'

const { Title } = Typography
const TotalItem = styled(Col)`
  padding: 20px;
  &:first-child:after {
    content: '';
    position: absolute;
    display: block;
    background: transparent;
    width: 1px;
    height: 30px;
    top: 50%;
    right: -1%;
    margin-top: -15px;
    border: 1px dashed #312d70;
    @media (max-width: 992px) {
      width: 80%;
      height: 1px;
      top: 100%;
      right: 10%;
    }

    @media (max-width: 768px) {
      content: unset;
    }
  }

  &:last-child:after {
    content: unset;
  }

  @media (max-width: 768px) {
    padding: 12px;
  }
`
const AlignRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const StyleLabel = styled.label`
  color: ${({ theme }) => theme.colors_v2.grey_1};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`
const StyledTitle = styled(Title)`
  margin-bottom: 0 !important;
  color: #ffffff !important;
  font-size: 20px !important;
  margin-top: 12px !important;
  line-height: 24px !important;

  @media (max-width: 768px) {
    font-size: 18px !important;
    margin-top: 8px !important;
  }
`
const Circle = styled.div`
  height: 24px;
  width: 24px;
  border: 8px solid;
  border-radius: 50%;
  border-color: ${(props) => props.variant || '#FFFFFF'};

  @media (max-width: 768px) {
    margin-top: 4px;
    width: 16px;
    height: 16px;
    border-width: 5px;
  }
`

const TextChanged = styled.label`
  margin-top: 12px !important;
  color: ${(props) => (props.type === 'success' ? '#2D912C' : '#D35D64')};
`

class StatisticItem extends Component {
  render() {
    const {
      title,
      value,
      changedValue,
      changedValueSuffix = '',
      changedValueDecimalScale = 0,
      changedLable = '24h',
      prefix,
      changedValuePrefix,
      color,
    } = this.props
    return (
      <TotalItem lg={12} span={24}>
        <Row align="top" justify="space-between">
          <Col>
            <Space align="start" size="middle">
              <Circle variant={color} />
              <div>
                <StyleLabel>{title}</StyleLabel>
                <StyledTitle level={5}>
                  <NumberFormat
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={0}
                    value={value}
                    prefix={prefix}
                  />
                </StyledTitle>
              </div>
            </Space>
          </Col>
          <AlignRight>
            <StyleLabel>{changedLable}</StyleLabel>
            <TextChanged type={changedValue < 0 ? 'danger' : 'success'}>
              <NumberFormat
                displayType="text"
                thousandSeparator={true}
                decimalScale={changedValueDecimalScale}
                prefix={changedValuePrefix && changedValue >= 0 ? changedValuePrefix : ''}
                suffix={changedValueSuffix}
                value={changedValue}
              />
            </TextChanged>
          </AlignRight>
        </Row>
      </TotalItem>
    )
  }
}
export default StatisticItem
